import TerritorialScaleChoose from "module/AZZKUModule/components/TerritorialScaleChoose"

export default function Step4( props ) {
   return <TerritorialScaleChoose {...props }/>
}